export enum TaskStatus {
	all = 'all',
	completed = 'completed',
	created = 'created',
}
export enum TaskStatusRu {
	all = 'Все',
	completed = 'Выполнено',
	created = 'Не выполнено',
}
export enum TaskName {
	TASKS = 'Задания',
	TASK = 'Задание',
	STATS = 'Статистика',
}
export enum PeriodNameEn {
	DAY = 'day',
	WEEK = 'week',
	MONTH = 'month',
	QUART = 'quart',
}
export enum SourceType {
	ORDER = 'order',
	SIDEBAR = 'sidebar',
}

export const arrStatus = [TaskStatus.all, TaskStatus.completed, TaskStatus.created]

export const pagesModalInfo = [
	{
		id: 1,
		title: 'Персональный помощник',
		text: `Каждый день мы проверяем — есть ли заявки, требующие внимания.
		Например, если Ваш клиент не подписал документы на подключение продукта в СберБизнес Онлайн,
		то вы увидите новое задание.
	`,
		src: '../img/task_modal_1.png',
	},
	{
		id: 2,
		title: 'Инструкции',
		text: `В каждом задании есть необходимые инструкции и реквизиты.
	Отмечайте задания выполненными после выполнения инструкций.
	При формировании актов вы получите дополнительное вознаграждение в зависимости от факта подключения продуктов.
	`,
		src: '../img/task_modal_2.png',
	},
	{
		id: 3,
		title: 'Панель управления',
		text: `В ближайшем будущем, мы подготовим отдельное пространство для управления заданиями 
		и отслеживания статистики по их выполнению.
	`,
		src: '../img/task_modal_3.png',
	},
]
